module.exports = __webpack_public_path__ + "static/1mile-9825eddc9e3843c2a0b0775ed8ff520b.png";